@use "@fukuri-admins/ui/layout" as *;

.headRow {
  background-color: background('Senary');
  white-space: nowrap;
}

.clientNameCol {
  min-width: 120px;
}

.nameCol {
  min-width: 100px;
}

.emailCol {
  min-width: 160px;
}

.branchCodeCol {
  min-width: 80px;
}

.linkedAtCol {
  min-width: 120px;
}

.billableFromCol {
  min-width: 144px;
}

.createdAtCol {
  min-width: 120px;
}

.updatedAtCol {
  min-width: 144px;
}

.actionCol {
  width: 60px;
  text-align: center;
}

.deleteItem {
  color: text('Red');
}
